<template>
  <multi-input class="component">
    <prefix>
      <label :for="filterElement.idForProp('filter')">
        <span class="icon searchable"></span>
      </label>
    </prefix>
    <column>
      <input
        v-model="q"
        @input="clearSearchIfExactMatchesOnly"
        @keyup.enter="handleEnterKey"
        type="search"
        :id="filterElement.idForProp('filter')"
        :placeholder="filterElement.placeholder_text"
      />
    </column>
    <suffix>
      <button @click="reset" type="reset" class="btn-icon">
        <span class="sr-only">clear</span>
        <span class="icon times"></span>
      </button>
    </suffix>
  </multi-input>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewFilterMixin from '../../../common/mixins/listViews/listViewFilterMixin'
  import {SearchMatchType} from "~/enums/searchMatchType";
  import HideListViewBus from "../buses/hideListViewBus";

  export default Vue.extend({
    mixins: [
      listViewFilterMixin,
    ],
    data: function () {
      return {
        SearchMatchType,
        rawQ: '',
      };
    },
    computed: {
      q: {
        get(): string {
          return this.rawQ
        },
        set(value: string) {
          this.rawQ = value.trim()
          // add dashes to rawQ to format it as an SSN
          if (this.filterElement.add_ssn_dashes) {
            this.rawQ = this.rawQ.replace(/-/g, '');
            // if first three digits exist, add a dash 
            if (this.rawQ.length > 3) {
              this.rawQ = this.rawQ.replace(/(\d{3})/, '$1-');
            }
            // if second two digits exist, add a dash
            if (this.rawQ.length > 6) {
              this.rawQ = this.rawQ.replace(/(\d{3})-(\d{2})/, '$1-$2-');
            }
          }
        }
      },
      exactMatchesOnly(): boolean {
        return (this.filterElement.match_type === SearchMatchType.ExactMatch)
          && this.filterElement.listView.hide_data_without_search
      }
    },
    methods: {
      setDefaultFilter(): void {
        this.q = this.queryValue
      },
      clearSearchIfExactMatchesOnly() {
        if (this.exactMatchesOnly) {
          this.clearFilter();
        }
      },
      clearQueryIfInvalid() {
      },
      reset(): void {
        this.q = ''
      },
      handleEnterKey(event): void {
        HideListViewBus.$emit('hideWhileSearching', true);
        this.q = event.target.value;
        this.updateQuery()
      },
      updateQuery() {
        if (this.q) {
          this.addFilterToQuery(this.q);
        } else {
          this.clearFilter();
        }
      },
    },
    watch: {
      rawQ: function() {
        if (this.exactMatchesOnly) return

        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.updateQuery()
        }, 1000);
      }
    }
  });
</script>